import React, { useState } from "react";
import FormControl from "@mui/material/FormControl";
import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import ErrorIcon from "images/cross_red.svg";
import SuccessIcon from "images/circle_green.svg";
import { message } from "components/common/Constants";

function NewPWInput(props) {
	const {
		classes,
		errors,
		control,
		register,
		atLeast8Valid,
		atLeast1Num,
		atLeast1LowAndUp,
		atLeast1Special,
		notContainEmail,
	} = props;
	const [showNewPassword, setShowNewPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	const WarnningMsg = (data) => {
		const styles = {
			marginLeft: "20px",
			paddingLeft: "20px",
			backgroundSize: "10px 10px",
			backgroundPositionY: "9px",
			backgroundRepeat: "no-repeat",
		};
		if (data.isSuccess)
			return (
				<div style={{ color: "green", backgroundImage: `url(${SuccessIcon})`, ...styles }}>{data.message}</div>
			);
		else return <div style={{ color: "red", backgroundImage: `url(${ErrorIcon})`, ...styles }}>{data.message}</div>;
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const handleClickShowNewPassword = () => {
		setShowNewPassword(!showNewPassword);
	};

	const handleClickShowConfirmPassword = () => {
		setShowConfirmPassword(!showConfirmPassword);
	};

	const handleInputChange = (field, e) => {
		const inputValue = e.target.value;
		const filteredValue = inputValue.replace(/\s/g, "");
		field.onChange(filteredValue);
	};

	return (
		<>
			<FormControl fullWidth sx={{ mb: "10px" }}>
				<Controller
					render={({ field }) => (
						<TextField
							{...field}
							{...register("newPwd")}
							label="New Password"
							type={"text"}
							size="small"
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											aria-label="toggle password visibility"
											onClick={handleClickShowNewPassword}
											onMouseDown={handleMouseDownPassword}
											size="large"
										>
											{showNewPassword ? <Visibility /> : <VisibilityOff />}
										</IconButton>
									</InputAdornment>
								),
							}}
							inputProps={{
								maxLength: 48,
								style: { fontFamily: showNewPassword || "text-security-disc" },
							}}
							onChange={(e) => handleInputChange(field, e)}
						/>
					)}
					control={control}
					name="newPwd"
					required
				/>
			</FormControl>
			<div>
				<WarnningMsg isSuccess={atLeast8Valid} message={message.AtLeast8Characters} />
				<WarnningMsg isSuccess={atLeast1Num} message={message.AtLeast1Number} />
				<WarnningMsg isSuccess={atLeast1LowAndUp} message={message.AtLeast1LowAndUp} />
				<WarnningMsg isSuccess={atLeast1Special} message={message.AtLeast1Special} />
				<WarnningMsg isSuccess={notContainEmail} message={message.NotContainEmail} />
			</div>
			<FormControl fullWidth sx={{ mt: "10px", mb: "10px" }}>
				<Controller
					render={({ field }) => (
						<TextField
							{...field}
							{...register("confirmPwd")}
							label="Confirm Password"
							// type={'text'}
							size="small"
							type={showConfirmPassword ? "text" : "password"}
							error={!!errors.confirmPwd}
							helperText={errors.confirmPwd?.message}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											aria-label="toggle password visibility"
											onClick={handleClickShowConfirmPassword}
											onMouseDown={handleMouseDownPassword}
											size="large"
										>
											{showConfirmPassword ? <Visibility /> : <VisibilityOff />}
										</IconButton>
									</InputAdornment>
								),
							}}
							inputProps={{
								maxLength: 48,
								style: { fontFamily: showConfirmPassword || "text-security-disc" },
							}}
							onChange={(e) => handleInputChange(field, e)}
						/>
					)}
					control={control}
					id="confirmPwd"
					name="confirmPwd"
				/>
			</FormControl>
		</>
	);
}

export default NewPWInput;
